import * as React from "react"
import request from "@/server/request"
import config from "@/server/config"
import alert from "@/pages/components/common/alert"
import "../scss/index.scss"
import { parse } from "query-string"

export default class CommodityMangement extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    const searchParams = parse(this.props.location.search)
    this.state = {
      companyId: searchParams.companyId || "", // 企业id
      showBatchIcon: false, // 显示批量操作
      productList: [],
      tabIndex: 0, // tab 索引
      statusIndex: searchParams.status || 1, // 状态索引 类型 1-上架 2-下架
      showTabDialog: false,
      goodList: [],
      storeTypesData: [], // 商铺分类
      storeTypesTwoData: [],
      storeTypesThreeData: [],
      storeTypesOneId: searchParams.cid1 || "",
      storeTypesOneName: searchParams.cname1 || "",
      storeTypesTwoId: searchParams.cid2 || "",
      storeTypesTwoName: searchParams.cname2 || "",
      storeTypesThreeId: searchParams.cid3 || "",
      storeTypesThreeName: searchParams.cname3 || "",
      plateformData: [], // 平台分类
      plateformTwoData: [],
      plateformThreeData: [],
      plateformOneId: searchParams.pid1 || "",
      plateformOneName: searchParams.pname1 || "",
      plateformTwoId: searchParams.pid2 || "",
      plateformTwoName: searchParams.pname2 || "",
      plateformThreeId: searchParams.pid3 || "",
      plateformThreeName: searchParams.pname3 || "",
      searchText: "",
      page: 1,
      goodsActiveArr: [], // 选中商品
      isSelectAll: false,
      // canReleaseGoods: false, // 能否发布商品
      // releaseGoodsMsg: '' // 无法发布商品原因
    }
  }

  public loadBtn = true

  public componentDidMount() {
    const _THIS = this

    this.getCommodityData()
    this.getStoreTypes()
    this.getPlateformData()

    // 检测是否能够发布商品
    // this.checkReleaseGoods();

    window.onscroll = function () {
      if (
        document.body.scrollHeight -
          document.body.scrollTop -
          window.innerHeight <
          50 ||
        document.body.scrollHeight -
          document.documentElement.scrollTop -
          window.innerHeight <
          50
      ) {
        if (!_THIS.loadBtn || _THIS.state.showBatchIcon) {
          return
        }
        // (document.querySelector('#loading') as HTMLElement).style.display = 'block';
        _THIS.setState(
          {
            page: _THIS.state.page + 1,
          },
          () => {
            if (_THIS.loadBtn) {
              _THIS.getCommodityData()
            }
          }
        )
      }
    }
  }

  public componentWillReceiveProps(props: any) {
    if (props.history.action !== "REPLACE") {
      return
    }
    const searchParams = parse(props.location.search)
    this.loadBtn = true
    this.setState(
      {
        statusIndex: searchParams.status,
        storeTypesOneId: searchParams.cid1 || "",
        storeTypesOneName: searchParams.cname1 || "",
        storeTypesTwoId: searchParams.cid2 || "",
        storeTypesTwoName: searchParams.cname2 || "",
        storeTypesThreeId: searchParams.cid3 || "",
        storeTypesThreeName: searchParams.cname3 || "",
        plateformOneId: searchParams.pid1 || "",
        plateformOneName: searchParams.pname1 || "",
        plateformTwoId: searchParams.pid2 || "",
        plateformTwoName: searchParams.pname2 || "",
        plateformThreeId: searchParams.pid3 || "",
        plateformThreeName: searchParams.pname3 || "",
        showTabDialog: false,
        page: 1,
        goodList: [],
      },
      () => this.getCommodityData()
    )
  }

  public render() {
    return (
      <div className="page-commodityMangement">
        {this.state.showTabDialog ? (
          <div className="dialog">
            <div className="dialog-content">
              <div className="commodity-classification">
                <div className="brush-list">
                  <div
                    className={`item ${
                      this.state.tabIndex === 0 ? "active" : ""
                    }`}
                    onClick={() => this.setTab(0)}
                  >
                    <span className="text">在售商品</span>
                    <i className="brush-icon" />
                  </div>
                  <div
                    className={`item ${
                      this.state.tabIndex === 1 ? "active" : ""
                    }`}
                    onClick={() => this.setTab(1)}
                  >
                    <span className="text">商品分类</span>
                    <i className="brush-icon" />
                  </div>
                  <div
                    className={`item ${
                      this.state.tabIndex === 2 ? "active" : ""
                    }`}
                    onClick={() => this.setTab(2)}
                  >
                    <span className="text">平台分类</span>
                    <i className="brush-icon" />
                  </div>
                </div>
                <div className="brush-list-view">
                  {this.state.tabIndex === 0 ? (
                    <div className="view-box">
                      <ul className="status-list">
                        <li
                          className={`${
                            this.state.statusIndex == 1 ? "active" : ""
                          }`}
                          onClick={() => this.ChangeStatus(1)}
                        >
                          在售商品
                        </li>
                        <li
                          className={`${
                            this.state.statusIndex == 2 ? "active" : ""
                          }`}
                          onClick={() => this.ChangeStatus(2)}
                        >
                          未上架
                        </li>
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.tabIndex === 1 ? (
                    <div className="view-box">
                      <div className="classification-warrper">
                        <div className="classification-list">
                          {this.state.storeTypesData.map(
                            (v: any, k: number) => {
                              return (
                                <span
                                  className={`lable-name line-clamp-1 ${
                                    this.state.storeTypesOneId === v.cate_id
                                      ? "active"
                                      : ""
                                  }`}
                                  key={k}
                                  onClick={() => this.ChangeStoreTypeData(v)}
                                >
                                  {v.cate_name}{" "}
                                </span>
                              )
                            }
                          )}
                        </div>
                        <div className="classification-list">
                          {this.state.storeTypesTwoData.map(
                            (v: any, k: number) => {
                              return (
                                <span
                                  className={`lable-name line-clamp-1 ${
                                    this.state.storeTypesTwoId === v.cate_id
                                      ? "active"
                                      : ""
                                  }`}
                                  key={k}
                                  onClick={() => this.ChangeStoreTypeTwoData(v)}
                                >
                                  {v.cate_name}
                                </span>
                              )
                            }
                          )}
                        </div>
                        <div className="classification-list">
                          {this.state.storeTypesThreeData.map(
                            (v: any, k: number) => {
                              return (
                                <span
                                  className={`lable-name line-clamp-1 ${
                                    this.state.storeTypesThreeId === v.cate_id
                                      ? "active"
                                      : ""
                                  }`}
                                  key={k}
                                  onClick={() =>
                                    this.ChangeStoreTypeThreeData(v)
                                  }
                                >
                                  {v.cate_name}
                                </span>
                              )
                            }
                          )}
                        </div>
                      </div>
                      <div className="classification-btn">
                        <button
                          className="btn"
                          onClick={() => this.emptyStoreTypes()}
                        >
                          重置
                        </button>
                        <button
                          className="btn comfirm"
                          onClick={() => this.onComfirm()}
                        >
                          确认
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.state.tabIndex === 2 ? (
                    <div className="view-box">
                      <div className="classification-warrper">
                        <div className="classification-list">
                          {this.state.plateformData.map((v: any, k: number) => {
                            return (
                              <span
                                className={`lable-name line-clamp-1 ${
                                  this.state.plateformOneId === v.cat_id
                                    ? "active"
                                    : ""
                                }`}
                                key={k}
                                onClick={() => this.ChangePlateformData(v)}
                              >
                                {v.cat_name}
                              </span>
                            )
                          })}
                        </div>
                        <div className="classification-list">
                          {this.state.plateformTwoData.map(
                            (v: any, k: number) => {
                              return (
                                <span
                                  className={`lable-name line-clamp-1 ${
                                    this.state.plateformTwoId === v.cat_id
                                      ? "active"
                                      : ""
                                  }`}
                                  key={k}
                                  onClick={() => this.ChangePlateformTwoData(v)}
                                >
                                  {v.cat_name}
                                </span>
                              )
                            }
                          )}
                        </div>
                        <div className="classification-list">
                          {this.state.plateformThreeData.map(
                            (v: any, k: number) => {
                              return (
                                <span
                                  className={`lable-name line-clamp-1 ${
                                    this.state.plateformThreeId === v.cat_id
                                      ? "active"
                                      : ""
                                  }`}
                                  key={k}
                                  onClick={() =>
                                    this.ChangePlateformThreeData(v)
                                  }
                                >
                                  {v.cat_name}
                                </span>
                              )
                            }
                          )}
                        </div>
                      </div>
                      <div className="classification-btn">
                        <button
                          className="btn"
                          onClick={() => this.emptyPlateform()}
                        >
                          重置
                        </button>
                        <button
                          className="btn comfirm"
                          onClick={() => this.onComfirm()}
                        >
                          确认
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="top">
          {!this.state.showBatchIcon ? (
            <div className="search-warrper">
              <input
                type="text"
                placeholder="名称、牌号、生产商"
                className="search-input"
                value={this.state.searchText}
                onChange={(e: any) =>
                  this.changeState("searchText", e.target.value)
                }
              />
              <span className="text" onClick={() => this.changeSearch()}>
                搜索
              </span>
            </div>
          ) : (
            ""
          )}
          {!this.state.showBatchIcon ? (
            <div className="brush-list">
              <div className="item">
                <span className="text" onClick={() => this.setTab(0)}>
                  {this.state.statusIndex == 1 ? "在售商品" : "未上架"}
                </span>
                <i className="brush-icon" />
              </div>
              <div className="item line-clamp-1">
                <span className="text" onClick={() => this.setTab(1)}>
                  {this.state.storeTypesOneId ||
                  this.state.storeTypesTwoId ||
                  this.state.storeTypesThreeId
                    ? this.state.storeTypesOneName +
                      `${this.state.storeTypesTwoName ? "," : ""}` +
                      this.state.storeTypesTwoName +
                      `${this.state.storeTypesThreeName ? "," : ""}` +
                      this.state.storeTypesThreeName
                    : "商品分类"}
                </span>
                <i className="brush-icon" />
              </div>
              <div className="item line-clamp-1">
                <span className="text" onClick={() => this.setTab(2)}>
                  {this.state.plateformOneId ||
                  this.state.plateformTwoId ||
                  this.state.plateformThreeId
                    ? this.state.plateformOneName +
                      `${this.state.plateformTwoName ? "," : ""}` +
                      this.state.plateformTwoName +
                      `${this.state.plateformThreeName ? "," : ""}` +
                      this.state.plateformThreeName
                    : "平台分类"}
                </span>
                <i className="brush-icon" />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          className={`commodit-list ${
            this.state.showBatchIcon ? "choose" : ""
          }`}
        >
          {this.state.goodList.map((v: any, k: number) => {
            return (
              <div className="item" key={k} onClick={() => this.goodsClick(v)}>
                {this.state.showBatchIcon ? (
                  <div
                    className={`radio-warrper ${
                      this.state.goodsActiveArr.indexOf(v.goods_id) !== -1
                        ? "active"
                        : ""
                    }`}
                  ></div>
                ) : (
                  ""
                )}

                <img src={v.img} alt="" className="cover" />
                <div className="content">
                  <p className="title line-clamp-1">
                    {v.goods_name} {v.grade}
                  </p>
                  <p className="price">{v.price}</p>
                  <p className="stock">库存: {parseInt(v.stock)}</p>
                </div>
                {!this.state.showBatchIcon ? <i className="right-icon" /> : ""}
              </div>
            )
          })}
          {this.state.goodList.length === 0 ? (
            <p className="loading-tips">没有更多数据</p>
          ) : null}
        </div>
        <div className="commodit-bottom">
          {!this.state.showBatchIcon ? (
            <div>
              {this.state.statusIndex == 1 && (
                <button
                  className="commodit-btn float-l ml-10"
                  onClick={() => this.showBatch()}
                >
                  批量管理
                </button>
              )}
              <button
                className="commodit-btn primary-btn float-r ml-24"
                onClick={() =>
                  this.props.history.push(
                    "/store/commodityMangement/types?cid=" +
                      this.state.companyId
                  )
                }
              >
                商品分类管理
              </button>
              <button
                className="commodit-btn float-r"
                onClick={() => this.releaseGoods()}
              >
                发布商品
              </button>
            </div>
          ) : (
            <div>
              <span className="select-all" onClick={() => this.selectAll()}>
                <i
                  className={`radio-warrper ${
                    this.state.isSelectAll ? "active" : ""
                  }`}
                ></i>
                全选
              </span>
              <button
                className="commodit-btn float-r ml-24"
                onClick={() => this.changeState("showBatchIcon", false)}
              >
                取消
              </button>
              <button
                className="commodit-btn waring-btn float-r ml-24"
                onClick={() => this.operaCommodity(3)}
              >
                删除
              </button>
              <button
                className="commodit-btn float-r"
                onClick={() =>
                  this.operaCommodity(this.state.statusIndex == 1 ? 2 : 1)
                }
              >
                {this.state.statusIndex == 1 ? "下架" : "上架"}
              </button>
            </div>
          )}
        </div>
      </div>
    )
  }

  // 分类确认 搜索
  private onComfirm() {
    this.ChangeStatus()
  }

  // 搜索
  private changeSearch() {
    this.loadBtn = true
    this.setState(
      {
        goodList: [],
        page: 1,
      },
      () => {
        this.getCommodityData()
      }
    )
  }

  // 显示批量
  private showBatch() {
    this.setState({
      showBatchIcon: true,
    })
  }

  // tab切换
  private setTab(i: number) {
    this.setState({
      tabIndex: i,
      showTabDialog: true,
    })
  }

  private changeState(k: string, v: any) {
    this.setState({
      [k]: v,
    })
  }
  // 商品
  private async getCommodityData() {
    if (!this.loadBtn) {
      return
    }

    this.loadBtn = false

    const r = await request({
      method: "post",
      url: `${config.MALLAPI}api/shop/goods/goods-list`,
      data: {
        companyId: this.state.companyId,
        page: this.state.page,
        keyName: this.state.searchText,
        type: this.state.statusIndex,
        goods_cate_fir: this.state.storeTypesOneId,
        goods_cate_sec: this.state.storeTypesTwoId,
        goods_cate_thr: this.state.storeTypesThreeId,
        platform_cate_fir: this.state.plateformOneId,
        platform_cate_sec: this.state.plateformTwoId,
        platform_cate_thr: this.state.plateformThreeId,
      },
    })

    if (r.error_code === 0) {
      if (this.state.page >= r.data.page_count) {
        this.loadBtn = false
      } else {
        this.loadBtn = true
      }

      this.setState({
        goodList: this.state.goodList.concat(r.data.list),
      })
    }
  }
  // 商品分类
  private async getStoreTypes() {
    const r = await request({
      method: "post",
      url: `${config.MALLAPI}api/wshop/shop/cate`,
      data: {
        companyId: this.state.companyId,
      },
    })

    if (r.error_code === 0) {
      let storeTypeData2 = []
      let storeTypeData3 = []

      if (this.state.storeTypesOneId) {
        const current2 = r.data.find(
          (v: any) => v.cate_id == this.state.storeTypesOneId
        )
        if (current2) {
          storeTypeData2 = current2.children
          const current3 = storeTypeData2.find(
            (v: any) => v.cate_id == this.state.storeTypesTwoId
          )
          if (current3) {
            storeTypeData3 = current3.children
          }
        }
      }

      this.setState({
        storeTypesData: r.data,
        storeTypesTwoData: storeTypeData2,
        storeTypesThreeData: storeTypeData3,
      })
    }
  }

  /**
   * 状态修改
   * @param index {number} 索引
   */
  private ChangeStatus(index?: number) {
    this.props.history.replace({
      pathname: "/store/commodityMangement",
      search: `?companyId=${this.state.companyId}&status=${
        index || this.state.statusIndex
      }&cid1=${this.state.storeTypesOneId}&cname1=${
        this.state.storeTypesOneName
      }&cid2=${this.state.storeTypesTwoId}&cname2=${
        this.state.storeTypesTwoName
      }&cid3=${this.state.storeTypesThreeId}&cname3=${
        this.state.storeTypesThreeName
      }&pid1=${this.state.plateformOneId}&pname1=${
        this.state.plateformOneName
      }&pid2=${this.state.plateformTwoId}&pname2=${
        this.state.plateformTwoName
      }&pid3=${this.state.plateformThreeId}&pname3=${
        this.state.plateformThreeName
      }`,
    })
  }

  private ChangeStoreTypeData(v: any) {
    this.loadBtn = true
    this.setState({
      storeTypesOneId: v.cate_id,
      storeTypesOneName: v.cate_name,
      storeTypesTwoData: v.children,
      storeTypesTwoId: "",
      storeTypesTwoName: "",
      storeTypesThreeId: "",
      storeTypesThreeName: "",
      storeTypesThreeData: [],
    })
  }

  private ChangeStoreTypeTwoData(v: any) {
    this.setState({
      storeTypesTwoId: v.cate_id,
      storeTypesTwoName: v.cate_name,
      storeTypesThreeData: v.children,
      storeTypesThreeId: "",
      storeTypesThreeName: "",
    })
  }

  private ChangeStoreTypeThreeData(v: any) {
    this.setState({
      storeTypesThreeId: v.cate_id,
      storeTypesThreeName: v.cate_name,
    })
  }

  private emptyStoreTypes() {
    this.loadBtn = true
    this.setState(
      {
        storeTypesTwoData: [],
        storeTypesThreeData: [],
        storeTypesOneId: "",
        storeTypesOneName: "",
        storeTypesTwoId: "",
        storeTypesTwoName: "",
        storeTypesThreeId: "",
        storeTypesThreeName: "",
      },
      () => {
        this.ChangeStatus(this.state.statusIndex)
      }
    )
  }

  // 平台分类
  private async getPlateformData() {
    const r = await request({
      method: "post",
      url: `${config.MALLAPI}api/wshop/goods/platform-cate`,
    })

    if (r.error_code === 0) {
      let plateformData2 = []
      let plateformData3 = []

      if (this.state.plateformOneId) {
        const current2 = r.data.find(
          (v: any) => v.cat_id == this.state.plateformOneId
        )
        if (current2) {
          plateformData2 = current2.children
          const current3 = plateformData2.find(
            (v: any) => v.cat_id == this.state.plateformTwoId
          )
          if (current3) {
            plateformData3 = current3.children
          }
        }
      }
      this.setState({
        plateformData: r.data,
        plateformTwoData: plateformData2,
        plateformThreeData: plateformData3,
      })
    }
  }

  private ChangePlateformData(v: any) {
    this.setState({
      plateformOneId: v.cat_id,
      plateformOneName: v.cat_name,
      plateformTwoData: v.children,
    })
  }

  private ChangePlateformTwoData(v: any) {
    this.setState({
      plateformTwoId: v.cat_id,
      plateformTwoName: v.cat_name,
      plateformThreeData: v.children,
    })
  }

  private ChangePlateformThreeData(v: any) {
    this.setState({
      plateformThreeId: v.cat_id,
      plateformThreeName: v.cat_name,
    })
  }

  private emptyPlateform() {
    this.loadBtn = true
    this.setState(
      {
        plateformTwoData: [],
        plateformThreeData: [],
        plateformOneId: "",
        plateformOneName: "",
        plateformTwoId: "",
        plateformTwoName: "",
        plateformThreeId: "",
        plateformThreeName: "",
      },
      () => {
        this.ChangeStatus()
      }
    )
  }

  // 商品点击
  private goodsClick(v: any) {
    // 如果不是批量操作而是单纯点击
    if (!this.state.showBatchIcon) {
      ;(this.props as any).history.push({
        pathname: "/store/commodityMangement/release",
        state: {
          companyId: this.state.companyId,
          goods_id: v.goods_id,
          operation: "edit",
          goods_status: v.goods_status,
        },
      })
    }

    // onClick={() => this.props.history.push({pathname: '/store/commodityMangement/release', state: { companyId: this.state.companyId }})}
    if (this.state.goodsActiveArr.indexOf(v.goods_id) === -1) {
      this.setState({
        goodsActiveArr: [...this.state.goodsActiveArr, v.goods_id],
      })
    } else {
      const index = this.state.goodsActiveArr.findIndex((id: any) => {
        return id === v.goods_id
      })
      if (index !== -1) {
        this.state.goodsActiveArr.splice(index, 1)
        this.setState({
          goodsActiveArr: this.state.goodsActiveArr,
        })
      }
    }
  }

  // 全选
  private selectAll() {
    if (!this.state.isSelectAll) {
      // let result = [];
      const result = this.state.goodList.map((v: any) => {
        return v.goods_id
      })

      this.setState({
        goodsActiveArr: result,
        isSelectAll: !this.state.isSelectAll,
      })
    } else {
      this.setState({
        goodsActiveArr: [],
        isSelectAll: !this.state.isSelectAll,
      })
    }
  }

  // 上下架
  private async operaCommodity(types: number) {
    if (this.state.goodsActiveArr.length <= 0) {
      alert.open({
        promptText: "商品不能为空！",
      })
      return
    }

    const r = await request({
      method: "post",
      url: `${config.MALLAPI}api/shop/goods/operate`,
      data: {
        companyId: this.state.companyId,
        ids: this.state.goodsActiveArr.join(),
        type: types,
      },
    })
    if (r.error_code === 0) {
      this.loadBtn = true
      this.setState(
        {
          goodsActiveArr: [],
          goodList: [],
          page: 1,
          showBatchIcon: false,
        },
        () => {
          this.getCommodityData()
        }
      )
    }
    alert.open({
      promptText: r.msg,
    })
  }

  // 检测能否发布商品
  // async checkReleaseGoods() {
  // 	const r = await request({
  // 		method: "post",
  // 		url: `${config.MALLAPI}api/shop/goods/goods-permission`,
  // 		data: {
  // 			companyId: this.state.companyId
  // 		}
  // 	})

  // 	if (r.error_code === 0) {
  // 		this.setState({
  // 			canReleaseGoods: true
  // 		});
  // 	} else {
  // 		this.setState({
  // 			releaseGoodsMsg: r.msg
  // 		});
  // 	}
  // }

  releaseGoods() {
    // if (!this.state.canReleaseGoods) {
    // 	return alert.open({
    // 		promptText: this.state.releaseGoodsMsg
    // 	});
    // }
    this.props.history.push({
      pathname: "/store/commodityMangement/release",
      state: { companyId: this.state.companyId },
    })
  }
}
